import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AddAdvertiserModal } from "@/StudioEditorV2/components/generation/AddAdvertiserModal";
import { AdvertiserSearch } from "@/StudioEditorV2/components/generation/AdvertiserSearch";
import { placesLanguage } from "@/StudioEditorV2/utils/placesLanguage";

// The new editor's API, whose Google Places search the briefing shares (EditorPageService apiBase).
const EDITOR_API = '/api/studio-editor-v2';

/**
 * AD-259: the briefing's advertiser, found with the editor's Google Places search (ordered by
 * the ad language's country) or added by hand. Only the name is kept: the briefing stores no
 * advertiser record.
 */
export const BriefingAdvertiserField = ({ value, onChange, language, label, placeholder, error }) => {

    const { t } = useTranslation();
    const [adding, setAdding] = useState(null);
    const name = (value || '').trim();

    return (
        <>
            <AdvertiserSearch
                value={name ? { name } : null}
                onSelect={(advertiser) => onChange(advertiser?.name || '')}
                onClear={() => onChange('')}
                onAddNew={(typed) => setAdding(typed || '')}
                addLabel={t('editorV2.generation.form.addNewAdvertiser')}
                apiBase={EDITOR_API}
                language={placesLanguage(language)}
                label={label}
                placeholder={placeholder}
                error={error}
            />
            <AddAdvertiserModal
                opened={adding !== null}
                initialName={adding || ''}
                onClose={() => setAdding(null)}
                onSubmit={(advertiser) => {
                    onChange(advertiser.name);
                    setAdding(null);
                }}
            />
        </>
    );
};
